class DreikonJS {
    constructor() {
        this.breakpoint = 300;
        this.header = document.querySelector('.header-sticky--active');
        this.init();
    }

    init() {
        this.headerSizing()
    }

    headerSizing() {
        window.addEventListener('scroll', () => {
            if (window.innerWidth < 768) {
                return;
            }
            if (window.scrollY >= this.breakpoint && !this.header.classList.contains('header--is-smaller')) {
                this.header.classList.add('header--is-smaller');
            } else if (window.scrollY < this.breakpoint && this.header.classList.contains('header--is-smaller')) {
                this.header.classList.remove('header--is-smaller');
            }
        });
    }
}

window.addEventListener('load', () => {
    new DreikonJS();
});